import { render, staticRenderFns } from "./BuyDishType.vue?vue&type=template&id=676e39da&scoped=true&"
import script from "./BuyDishType.vue?vue&type=script&lang=js&"
export * from "./BuyDishType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e39da",
  null
  
)

export default component.exports